import { Children, cloneElement, isValidElement, ReactNode } from 'react';
import ItemMenu from '../ItemMenu';

const MinhaContaBtn = ({ children }: { children: ReactNode }) => {

	const MinhaContaChild = Children.map(children, (child) => {
		if (isValidElement(child) && child.type === ItemMenu) {
			return cloneElement(child as React.ReactElement<{ className?: string }>, {
				className: 'gap-2 px-2 py-2.5',
			});
		}
		return null;
	});

	return <>{MinhaContaChild}</>;
};

export default MinhaContaBtn;
